import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Badge } from 'module-tsl-ui-elements';
import WithDocgen from 'module-tsl-ui-elements/with-docs/badge/Badge';
import pkg from 'module-tsl-ui-elements/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`
    <div>
      <Badge size="lg">Large Badge</Badge>
      <Badge>Medium Badge (Default)</Badge>
      <Badge size="sm">Small Badge</Badge>
      <Badge inverse>Inverse Badge</Badge>
    </div>
  `}
  scope={ { Badge } }
/>
<LiveCode
  code={`
    <div>
      <Badge statusBadge>Status Badge</Badge>
      <Badge statusBadge theme="french-rose">Status Badge french-rose</Badge>
      <Badge statusBadge theme="purple-heart">Status Badge purple-heart</Badge>
      <Badge statusBadge theme="cerulean">Status Badge cerulean</Badge>
      <Badge statusBadge theme="burning-orange">Status Badge burning-orange</Badge>
      <Badge statusBadge theme="caribbean-green">Status Badge caribbean-green</Badge>
      <Badge statusBadge theme="electric-lime">Status Badge electric-lime</Badge>
      <Badge statusBadge theme="broom">Status Badge broom</Badge>
      <Badge statusBadge theme="cornflower-blue">Status Badge cornflower-blue</Badge>
    </div>
  `}
  scope={ { Badge } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-elements --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  